import { useParams } from 'react-router-dom';
import { LessonOutlet } from '../features/lecture';

// Route shell for a lesson. The lecture player (mounted via LessonOutlet) owns
// the TopBar title — it sets the real lesson title via useShellTitle once loaded,
// so we deliberately do not set a generic title here (that would clobber it).
export default function LecturePage() {
  const { lessonId } = useParams();
  return (
    <div className="h-full">
      <LessonOutlet lessonId={lessonId} />
    </div>
  );
}
